export enum TravelRequestTemplateType {
  BULGARIA = 'BULGARIA',
  ABROAD = 'ABROAD',
}
